<template>
  <div class="page-container">
    <div
      class="upper__text--container"
      :style="
        selectedCompany?.foto_capa_totem ? 
        {
          backgroundImage: `url('${selectedCompany.foto_capa_totem}')`,
        } : {}
      "
    >
    <button class="btn-back" @click="goBack">
      <img
        src="../../public/img/chevron-left-light.svg"
        style="width: 30px"
      />
    </button>
      <img
        src="../../public/img/icons/hermes-icon.png"
        alt="Logo Hermes"
        style="width: 60px; z-index: 1;"
      />
      <h1>Recepção Virtual</h1>
    </div>
    <div class="bottom-content">
      <div class="line-big" />
      <span class="side-text">
        Seja bem vindo a recepção virtual Hermes, para prosseguir você só
        precisa selecionar a empresa a qual tem algo a tratar
      </span>
    </div>
    <div class="list-container">
      <SelectCompany
        v-if="companies.length > 0"
        :companies="companies"
        :selectedCompany="selectedCompany"
        @selectedCompany="setCompany"
        @onRedirect="handleRedirect"
      />
    </div>
  </div>
</template>
<script>
import CompanyCard from "../components/CompanyCard.vue";
import SelectCompany from "../components/SelectCompanyList.vue";
import SideContainer from "../components/SideContainer.vue";
import config from "../config";
import CompanyService from "../services/CompanyService";

export default {
  components: {
    CompanyCard,
    SideContainer,
    SelectCompany,
  },
  data() {
    return {
      companyService: new CompanyService(),
      companies: [],
      conf: config,
      colors: ["#3C1313", "#5F3008", "#33064B"],
      selectedCompany: this.$store.state.schedule.company || {},
    };
  },
  methods: {
    setCompany(company) {
      this.selectedCompany = company;
      if(this.$store.state.schedule.company.id === company.id) {
        this.handleRedirect(company);
      }
      this.$store.commit("setScheduleCompany", this.selectedCompany);
    },
    async fetchCompanies() {
    this.$store.commit("setIsLoading", true);
      try {
        const response = await this.companyService.getCompaniesByIdent({
          ident: this.$store.state.ident_totem,
        });

        this.companies = response.data.map((company) => ({
          id: company.id_instituicao,
          nome: company.nome,
          foto_capa_desktop: company.foto_capa_desktop,
          foto_perfil_totem: company.foto_perfil_totem,
          foto_capa_totem: company.foto_capa_totem,
          logo_empresa: company.logo_empresa,
          cor_empresa:
            this.colors[Math.floor(Math.random() * this.colors.length)],
        }));

      } catch (error) {
        console.error("Erro ao buscar empresas:", error);
      }
      this.$store.commit("setIsLoading", false);
    },
    clearVisitorSchedule() {
      this.$store.commit("setScheduleCompany", {});
      this.$store.commit("setScheduleDepartment", {});
      this.$store.commit("setScheduleName", "");
      this.$store.commit("setScheduleReason", "");
      this.$store.commit("setSchedulePhoto", "");
    },
    redirectToFacialRecognition() {
      this.$router.push({ name: "facial-recognition" });
    },
    redirectToDepartments(company) {
      this.$router.push({
        name: "departments",
        params: { companyId: company.id },
      });
    },
    handleRedirect(company) {
      this.isNonScheduledRoute
        ? this.redirectToDepartments(company)
        : this.redirectToFacialRecognition();
    },
    goBack(){
      this.$router.push({ name: "home" });
    }
  },
  computed: {
    isNonScheduledRoute() {
      return this.$route.name === "non-scheduled";
    },
    isEmployee() {
      return this.$route.name === "employees";
    },
  },
  mounted() {
    this.clearVisitorSchedule();
    this.fetchCompanies();
  },
};
</script>

<style scoped>
.page-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  width: 100vw;
  position: relative;
}

.header-overlay {
  width: 100%;
  height: 100%;
  padding: none;
  position: absolute;
  top: 0px;
  height: 60%;
  opacity: 0.4;
  z-index: 0;
}

.list-container {
  position: absolute;
  top: 50vh;
  right: 0px;
  width: 60%;
  margin-right: 10px;
  z-index: 80;
  display: flex;
  align-items: center;
  width: 60%;
  height: 30%;
  gap: 1px;
}

.upper__text--container {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  padding: 0px 70px;
  width: 100%;
  height: 60%;
  background-size: cover; 
  background-position: center;
  background-repeat: no-repeat;
}

.upper__text--container h1 {
  font-size: 6vw;
  width: 30%;
  font-weight: bold;
  color: #fff;
  margin: 0;
  z-index: 1;
}

.upper__text--container p {
  font-size: 16px;
  color: #fff;
  margin: 5px 0 0;
}

.bottom-content {
  width: 100%;
  min-height: 40%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: white;
  bottom: 0px;
  padding: 0px 70px;
  gap: 30px;
   z-index: 1;

  span {
    width: 20%;
  }
}

.btn-back {
  /* position: absolute;
  top: 10px;
  left: 3%; */
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  margin-bottom: 20px;
}
</style>
